import React,{useEffect,useRef,useState} from 'react'
import WebTemplate from '../Components/WebTemplate'
import hero from '../assets/img/hero-img.png'
import background from '../assets/img/cover10.jpg'

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
import man1 from "../assets/img/founders/man1.jpg";
import man2 from "../assets/img/founders/man2.jpg";
import man3 from "../assets/img/founders/man3.jpg";
import man4 from "../assets/img/founders/man4.jpg";

import VideoPopup from '../Components/VideoPopup';
import { NavLink } from 'react-router-dom';

function Home() {
  const sectionStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    // Add any other desired background properties
  };

    const HomeScreen=()=>{        
        return(
            <>
           <section class="hero">
  <div class="hero-content">
    <h2 className="text-overlay" style={{color:'#ffffff'}}>Welcome to Sangli Shikshan Sanstha</h2>
   
  </div> 
</section>
{/* <section class="scrolling-text" style={{padding:'10px'}}>
  <div class="scrolling-text-content">
    <p>This is a scrolling text section. Hover to stop.</p>
  </div>
</section> */}

               {/* <section id="hero" style={sectionStyle}>

<div class="container">
  <div class="row">
    <div style={{textAlign:'center'}} data-aos="fade-up" data-aos-delay="200">
      <h1 style={{color:'white',fontSize:'40'}} className="text-overlay"> Welcome to Sangli Shikshan Sanstha</h1>
      <h2>Some Text</h2>
     
    </div>
 
  </div>
</div>

</section> */}
              <main id="main">
              <section id="clients" class="clients section-bg">
      <div class="container">

        <div class="row" data-aos="zoom-in">

        

        </div>

      </div>
    </section>
    <section id="services" class="services">
      <div class="container" data-aos="fade-up">
      <div class="section-title">
          <h4 style={{color:'#01091E'}}>
            {/* <a href='https://drive.google.com/drive/folders/1NZW-OYU3jUdAvORpqGP7U9xjLZkpdMsN?usp=drive_link' target='_blank'>
            गुणवत्ता व शताब्दी शिष्यवृत्ती परीक्षा बक्षिस समारंभ कार्यक्रमाचे फोटो (2025) पाहण्यासाठी येथे क्लिक करा 
            </a> */}
          {/* <NavLink 
             to='/examanswersheet'
             
             >
            1 फेब्रुवारी 2026 रोजी झालेल्या गुणवत्ता शोध व शताब्दी शिष्यवृत्ती परीक्षांच्या अंतिम उत्तरसूची पाहण्यासाठी येथे क्लिक करा
            </NavLink> */}

             {/* <NavLink 
             to='/examanswersheet'
             
             >
         इ.१ली, २री, ३री, ६वी गुणवत्ता शोध परीक्षा तसेच ४थी व ७वी शताब्दी परीक्षा चा अंतरीम निकाल दि. ३० मार्च २०२६ रोजी जाहीर केला जाणार आहे.

            </NavLink> */}

            <NavLink 
             to='/resultlanding'
             
             >
           गुणवत्ता शोध परीक्षा 2025-26 अंतिम निकाल पाहण्यासाठी क्लिक करा
            </NavLink>
          
            </h4>
          {/* <p>Some Text</p> */}
        </div>

        <div class="section-title">
          <h2 style={{color:'#01091E'}}>आदरणीय संस्थापक</h2>
          {/* <p>Some Text</p> */}
        </div>

        <div class="row">
          <div class="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box">
              <div class="icon">
                {/* <img src="https://fastly.picsum.photos/id/648/200/200.jpg?hmac=Kb_qhDdDfOGevrbabLvz4Tp3fu-M7DxQE6APqQRnwVw"/> */}
                <img src={man1} alt=""  class="img-fluid"/>
                {/* <i class="bx bxl-dribbble"></i> */}
                </div>
              <h4 style={{fontSize:'20px'}}>ब्रह्मीभूत गुरुनाथ गोविंद तोरो</h4>
              
            </div>
          </div>

          <div class="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box">
              <div class="icon">
                {/* <img src="https://fastly.picsum.photos/id/648/200/200.jpg?hmac=Kb_qhDdDfOGevrbabLvz4Tp3fu-M7DxQE6APqQRnwVw"/> */}
                <img src={man2} alt=""  class="img-fluid"/>
                {/* <i class="bx bxl-dribbble"></i> */}
                </div>
              <h4 style={{fontSize:'20px'}}>कै. राजाराम रावजी चिकोडीकर</h4>
             
            </div>
          </div>

          <div class="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box">
              <div class="icon">
                {/* <img src="https://fastly.picsum.photos/id/648/200/200.jpg?hmac=Kb_qhDdDfOGevrbabLvz4Tp3fu-M7DxQE6APqQRnwVw"/> */}
                <img src={man3} alt=""  class="img-fluid"/>
                {/* <i class="bx bxl-dribbble"></i> */}
                </div>
              <h4 style={{fontSize:'20px'}}>कै. विनायक सदाशिव जोशी</h4>
            
            </div>
          </div>

          <div class="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box">
              <div class="icon">
                {/* <img src="https://fastly.picsum.photos/id/648/200/200.jpg?hmac=Kb_qhDdDfOGevrbabLvz4Tp3fu-M7DxQE6APqQRnwVw"/> */}
                <img src={man4} alt=""  class="img-fluid"/>
                {/* <i class="bx bxl-dribbble"></i> */}
                </div>
              <h4 style={{fontSize:'20px'}}>कै. धोंडो विठ्ठल सखदेव</h4>
             
            </div>
          </div>

        </div>

      </div>
    </section>
    
<section id="about" style={{backgroundColor:'rgb(249, 249, 249)'}} class="about">
  <div class="container" data-aos="fade-up">

    <div class="section-title">
      <h2 style={{color:'black'}}>संस्थेची स्थापना</h2>
    </div>

    <div class="row content ">
      <div class="col-lg-12">
        <p>
        ४ डिसेंबर १९१४ या दिवशी लो. टिळक मंडालेहून सुटले साऱ्या भारतवासियांचा आनंद गगनात मावेना. आनंदू रे आजी आनंदू अशीच सर्व आबालवृध्दांची स्थिती झाली. मरगळेल्या राष्ट्रात नवचैतन्य निर्माण करणारा हा पोलादी पुरुष बघून ब्रिटीशांचे कणखर पाशही ढिले पडले. कर्मयोगावर नितांत श्रध्दा ठेवणारे लोकमान्य मंडाल्याहून सुटेल. गीता रहस्य या महान ग्रंथाची निर्मिती करुनच एका आगळ्या वेगळ्या निश्चयाने, खंबीरपणाने भारतात परतले. अवघ्यांचे डोळे पाणावले. या भारतमातेच्या सुपुत्राला पाहून लो. टिळकांच्या सुटकेचा आनंद अनेकांनी नानाविध मार्गांनी प्रकट केला. कुणी पेढे वाटले, कुणी साखर वाटली. कुणी गुलाल उधळला तर कुणी चक्क फुलेसुध्दा उधळली तर कोणी आनंदाचा मोतीचुरा पसरून दिला आणि त्या वाटेवरुन लोकमान्यांच्या जयजयकाराच्या घोषणा दाहीदिशांना दुमदुमल्या. अवघी अवनी बेहोशली.
        </p>
        <p>
        पण सांगलीतल्या चार तरुणांनी... ध्येयवेड्या युवकांनी वेगळ्या प्रकारच्या आनंदाचा संकल्प सोडला. लोकमान्यांचे आवडते कार्य... राष्ट्रीय शिक्षणाचे कार्य... मोठ्या जिद्दीने चालू ठेवण्यासाठी या वेड्या पोरांनी चक्क शाळेची स्थापना केली. सिटी स्कूल असे नामाभिधानही करण्यात आले... स्वदेशी, स्वराज्य, राष्ट्रीय शिक्षण, बहिष्कार या लोकमान्यांच्या चतु:सूत्रीचा उद्घोष करीत वेदपठणाला सुरुवात झाली. देशभक्तीची स्फूर्ती घेऊन हे चार वेडे तरुण एकत्र आले ते नवीनच इर्षा मनी बाळगून ! राष्ट्रीय विचारांची शाळा काढायची या कृतनिश्चयाने पेटून उठले. आणि त्या इर्षेने एक वेगळेच विधायक वळण घेतले आणि शाळेची मुहूर्तमेढ रोवली गेली.
        </p>
        <p>
        १ विद्यार्थी आणि ४ शिक्षक अशा व्यस्त प्रमाणात सुरु झालेल्या सिटीस्कूल. जनार्दन वासुदेव खाडिलकर हे त्या पहिल्या विद्यार्थ्याचे नांव व कै. वि.स. जोशी, ब्रह्मीभूत गु.गो. तोरो, कै. धों. वि. सखदेव आणि कै. रा. रा. चिकोडीकर हे ते चार शिक्षक. कालांतराने सन १९१९ मध्ये ही शाळा विस्तारीत झाली आणि सांगली एज्युकेशन सोसायटी अशा नावाने नोंदणीकृत झाली. आज सांगली शिक्षण संस्थेच्या १२ माध्यमिक शाळा, ८ प्राथमिक शाळा, ८ पूर्व प्राथमिक शाळा, २ इंग्रजी माध्यमाच्या प्राथमिक शाळा, ३ कनिष्ठ महाविद्यालये, १ अध्यापक महाविद्यालय आणि महाराष्ट्र राज्यात अव्वल स्थानावर असलेली मुलांची सैनिकी शाळा अशा विस्तारीत स्वरुपातील शाखांचा कारभार उत्तम पध्दतीने सांभाळला जात असून सिटी हायस्कूल, सांगली येथे असलेल्या संस्थेच्या मुख्य कार्यालयातून हा कारभार दक्षतेने सांभाळला जातो. सांगली शहरातील ६ वास्तू अगदी मोक्याच्या ठिकाणी आहेत तर सांगली जिल्ह्यातील विटे, तासगांव, लेंगरे, माधवनगर, बुधगाव, अंकली, हरीपूर येथे प्रत्येक शाळेस सोयीची व सर्वांना योग्य लाभ घेता यावा अशा ठिकाणी शाळा स्वतःच्या मालकीच्या सुसज्ज इमारतींसह उभ्या आहेत. या शाळांचा उज्ज्वल इतिहास पाहता एक यशोमालिकाच नजरेसमोर उभी राहते. आजही संस्था शाळा व गुणी विद्यार्थ्यांच्या रुपाने महाराष्ट्रातच नव्हे तर साऱ्या भारतवर्षात व परदेशीसुध्दा आपली प्रतिष्ठा टिकवून आहे. संस्थेचे नामवंत, कीर्तिवंत विद्यार्थी उच्चपदांवर जगभर कार्यरत आहेत.
        </p>
       
      </div>
      
    </div>

  </div>
</section>

{/* <footer id="footer">
<div class="footer-newsletter">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6" >
        <h4 style={{color:'white'}}>Find us On</h4>
        <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
        <i class="fa fa-youtube-play fa-3x "
       style={{paddingRight: "1em"}}
         aria-hidden="true"></i>
        <i class="fa fa-spotify fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
        <i class="fa fa-instagram fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
        <i class="fa fa-linkedin fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
        <i class="fa fa-facebook-square fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
</footer> */}


</main>
            </>
        )
    }
  return (
  <WebTemplate>
    {HomeScreen()}
  </WebTemplate>
  )
}

export default Home